module.exports = __webpack_public_path__ + "static/media/swe-off.75863d93.png";